export const OFFICIAL = {
  phd: 'https://enu.kz/ru/page/for-students/phd',
  internship: 'https://enu.kz/ru/page/for-students/phd/scientific-internshi',
  practice: 'https://enu.kz/ru/page/education/career/practice',
  smart: 'https://smart.enu.kz/',
  defense:
    'https://web.enu.kz/ru/page/university/management-and-structure/intra-university-structures/dissertation-council',
  regulations: 'https://enu.kz/ru/page/science/dissertation-tips/regulatory-documents',
  degree: 'https://adilet.zan.kz/rus/docs/V1100006951',
  employmentRules: 'https://adilet.zan.kz/rus/docs/V2300033291',
  educationLaw: 'https://adilet.zan.kz/rus/docs/Z070000319_',
  employmentChange2025: 'https://adilet.zan.kz/rus/docs/V2500037209',
};

export const PRACTICE_VIDEOS: [string, string][] = [
  ['Создание графика-плана по практике', 'https://www.youtube.com/watch?v=pjEm5EpHjqA'],
  ['Внесение результатов в график-план', 'https://www.youtube.com/watch?v=Xx2yegvxpxo'],
  ['Проверка дневника-отчёта', 'https://www.youtube.com/watch?v=evAkXZD27TA'],
  ['Создание дневника-отчёта', 'https://www.youtube.com/watch?v=Ozis9drNzbY'],
  ['Подписание документа контрагентом', 'https://www.youtube.com/watch?v=C66wW6p6CEg'],
  ['Загрузка отчёта по практике', 'https://www.youtube.com/watch?v=ddDMONbg4I0'],
];

export const DEFENSE_STEPS = [
  {
    title: '1. Предзащита',
    desc: 'Расширенное заседание кафедры: диссертация и основной комплект должны быть готовы.',
    docs: [
      'Диссертация PDF / рабочая печатная версия',
      'Отзывы: кафедральные рецензенты, научный руководитель, зарубежный консультант',
      'Публикации и оттиски',
      'Презентация 15–20 минут',
      'Лист присутствия',
      'Протокол / акт внедрения — если применимо',
    ],
  },
  {
    title: '2. Этическая комиссия',
    desc: 'Получение заключения Комиссии по этической оценке исследований.',
    docs: [
      'Заявление',
      'Полная диссертация',
      'Отзывы',
      'Протокол предзащиты',
      'Предварительная проверка заимствований',
      'Техническая проверка / подтверждение',
    ],
  },
  {
    title: '3. Допуск к защите',
    desc: 'Передача полного комплекта в диссертационный совет и назначение официальных рецензентов.',
    docs: [
      'Отзывы консультантов',
      'Положительное заключение кафедры',
      'Диссертация',
      'Список научных трудов и копии',
      'Заключение этической комиссии',
      'Транскрипт',
      'Личный лист / необходимые персональные документы',
      'Заявление на защиту',
      'Аннотация на трёх языках',
      'Документ о допуске / назначении защиты',
    ],
  },
  {
    title: '4. Защита',
    desc: 'Публичная процедура: материалы на сайте, рецензенты, антиплагиат, презентация и заседание.',
    docs: [
      'Объявление / информация о защите',
      'Аннотация KZ / RU / EN',
      'Диссертация PDF',
      'Список научных трудов',
      'Отзывы консультантов',
      'Этическое заключение',
      'Отзывы официальных рецензентов',
      'Результат проверки заимствований',
      'Проект заключения диссовета',
      'Презентация',
      'Техническая готовность аудитории / онлайн-подключения',
    ],
  },
  {
    title: '5. После защиты',
    desc: 'Фиксация результата защиты и оформление завершающих документов.',
    docs: [
      'Протокол / решение диссертационного совета',
      'Видео / ссылка на запись, если требуется',
      'Документы регистрации диссертации',
      'Передача материалов в библиотеки / репозитории по действующей процедуре',
      'Аттестационное дело',
      'Данные диплома PhD после выдачи',
    ],
  },
];

export const ARCHIVE_DOCS: [number, string, string, string, string][] = [
  [1, 'Личная карточка докторанта с приказами по движению', 'Офис регистратора', 'office', 'Автоподтяжка / сверка'],
  [2, 'Транскрипт докторанта', 'Офис регистратора', 'office', 'Автоподтяжка / сверка'],
  [3, 'Личный листок по учёту кадров + подтверждение трудовой деятельности', 'Докторант', 'user', 'Загрузить'],
  [4, 'Заявление на имя Председателя Правления–Ректора', 'Служебный контур', 'office', 'Не редактируется здесь'],
  [5, 'Копия удостоверения личности', 'Докторант', 'user', 'Загрузить'],
  [6, 'Копия документа об образовании', 'Из личного дела / по запросу', 'office', 'Сверка; загрузка только по запросу'],
  [7, 'Договор по оказанию образовательных услуг', 'Университет / личное дело', 'office', 'Сверка'],
  [8, 'Договор по оказанию платных образовательных услуг — при наличии', 'Университет / личное дело', 'office', 'Если применимо'],
  [9, 'Официальный сертификат КАЗТЕСТ', 'Из личного дела / по запросу', 'office', 'Сверка'],
  [10, 'Сертификат иностранного языка (IELTS, TOEFL и др.)', 'Из личного дела / по запросу', 'office', 'Сверка'],
  [11, 'Список научных трудов', 'Докторант', 'user', 'Сформировать / загрузить'],
  [12, 'Медицинская справка №075/у', 'Из личного дела / по запросу', 'office', 'Сверка'],
  [13, 'Выписка из приказа о зачислении', 'Офис регистратора', 'office', 'Автоподтяжка / сверка'],
  [14, 'Характеристика на выпускника', 'Кафедра', 'department', 'Оформляет кафедра · есть образец'],
  [15, 'Прочие особо важные документы — при наличии', 'Докторант / кафедра', 'user', 'Условная загрузка'],
  [16, 'Обходной лист', 'Технический секретарь / кафедра', 'tech', 'Обязателен · отдельная инструкция'],
];

export const GUIDE_TERMS: [string, string, string, string][] = [
  ['PhD / докторантура', 'Послевузовская образовательная программа, в которой обучение, исследование, публикации, практики, стажировка и диссертация образуют один маршрут. Для 8D01717 типичный срок — 3 года, общий объём — 180 академических кредитов.', '◉', '#42d8ff'],
  ['Докторант', 'Обучающийся, который ведёт собственное цифровое досье, выполняет ИУП и НИРД, проходит практики и стажировку, формирует публикационные результаты и готовит диссертацию.', 'D', '#42d8ff'],
  ['Advisor / куратор', 'Организационно сопровождает докторанта с 1 по 3 курс: помогает со сроками, документами, практиками, стажировкой, аттестацией, выпускными действиями и общей комплектностью. Advisor не заменяет научного руководителя.', 'A', '#4ce2bf'],
  ['Научный руководитель', 'Сопровождает научную часть: тему, исследовательские задачи, методологию, диссертацию, публикации, консультации и научную готовность к защите.', 'S', '#9b7cff'],
  ['Зарубежный консультант', 'Участвует в научном консультировании и международной части траектории; для назначения формируется отдельный пакет документов.', 'I', '#f1b93f'],
  ['ИУП', 'Индивидуальный учебный/рабочий план — персональная трёхлетняя карта докторанта. Он связывает дисциплины, НИРД, практики, стажировку, публикационный план и диссертацию.', 'P', '#42d8ff'],
  ['НИРД / ДҒЗЖ', 'Научно-исследовательская работа докторанта. В цифровом досье — шесть семестровых отчётов с подтверждающими материалами и статусом проверки.', '6', '#9b7cff'],
  ['Аттестация', 'Периодическая проверка выполнения плана и научной работы. Система должна заранее показывать готовность, просрочки и недостающие позиции.', '✓', '#4ce2bf'],
  ['Педагогическая практика', 'Практический педагогический компонент. По ОП 2025 она находится в 3 семестре и составляет 10 кредитов.', 'PP', '#4ce2bf'],
  ['Исследовательская практика', 'Исследовательский практический компонент. По ОП 2025 она находится в 4 семестре и составляет 10 кредитов.', 'RP', '#4ce2bf'],
  ['Научная стажировка', 'Отдельный научный маршрут с организацией, приглашением, планом, приказом, отчётом и подтверждением прохождения.', 'S', '#42d8ff'],
  ['Публикационная готовность', 'Состояние публикационных результатов относительно действующей редакции требований к присуждению степени.', '∑', '#f1b93f'],
  ['Предзащита', 'Кафедральная проверка диссертации и основного пакета перед переходом к официальному защитному маршруту.', 'P', '#f1b93f'],
  ['Этическая комиссия', 'Этап получения заключения по соблюдению этических требований исследования, когда он требуется действующими процедурами.', 'E', '#9b7cff'],
  ['Диссертационный совет', 'Орган, в котором проходит официальная процедура защиты в соответствии с применимыми правилами и регламентом.', 'DC', '#9b7cff'],
  ['Обходной лист', 'Выпускной процесс закрытия обязательств перед университетскими подразделениями.', '↻', '#ff7968'],
  ['Архивное дело', 'Комплект личного дела выпускника докторантуры, который собирается, проверяется, прошивается и передаётся по университетской процедуре.', 'A', '#ff7968'],
  ['Отработка государственного заказа', 'После завершения обучения применяется только при наличии соответствующей обязанности; место и основание проверяются по действующей редакции правил.', 'W', '#f1b93f'],
];

export const GUIDE_COURSES: {
  year: number;
  color: string;
  title: string;
  credits: string;
  intro: string;
  end: string;
  semesters: [string, string[]][];
}[] = [
  {
    year: 1,
    color: '#42d8ff',
    title: '1 курс',
    credits: '60 кредитов',
    intro:
      'Первый год формирует основу всей траектории. Помимо дисциплин, докторант оформляет научную тему, руководителя и зарубежного консультанта, утверждает индивидуальный план и начинает НИРД.',
    end: 'должны быть сформированы базовые академические и научные данные, утверждена рабочая траектория и закрыты первые два семестровых НИРД.',
    semesters: [
      ['1 семестр', ['Теоретические дисциплины и элективы по ОП 8D01717', 'Академическое письмо — 5 кредитов', 'НИРД-1 — 20 кредитов', 'Подготовка темы, руководителя и зарубежного консультанта', 'Формирование индивидуального плана']],
      ['2 семестр', ['Методы научных исследований — 5 кредитов', 'Научно-методические основы обучения казахскому языку / литературе — 5 кредитов', 'НИРД-2 — 15 кредитов', 'Публикационная работа и выполнение индивидуального плана', 'Семестровая аттестация']],
    ],
  },
  {
    year: 2,
    color: '#4ce2bf',
    title: '2 курс',
    credits: '60 кредитов',
    intro:
      'Второй год переводит докторанта к профессиональной и исследовательской работе. Педагогическая практика приходится на 3 семестр, исследовательская — на 4 семестр.',
    end: 'основной акцент — практики и развитие исследования; подтверждающие документы хранятся в соответствующих рабочих разделах.',
    semesters: [
      ['3 семестр', ['Педагогическая практика — 10 кредитов, итог: отчёт', 'НИРД-3 — 20 кредитов', 'Работа над диссертацией по индивидуальному плану', 'Публикации и подтверждающие результаты', 'Семестровая аттестация']],
      ['4 семестр', ['Исследовательская практика — 10 кредитов, итог: отчёт', 'НИРД-4 — 20 кредитов', 'Работа с научными базами и эмпирическим материалом', 'Продолжение публикационной траектории', 'Семестровая аттестация']],
    ],
  },
  {
    year: 3,
    color: '#9b7cff',
    title: '3 курс',
    credits: '60 кредитов',
    intro:
      'Третий год завершает образовательную программу: НИРД-5/6, научная стажировка, завершение диссертации и проверка публикационной и защитной готовности.',
    end: 'завершается образовательная программа, но степень PhD возникает только после успешной защиты. Защитный контур остаётся доступным и после 3 курса.',
    semesters: [
      ['5 семестр', ['НИРД-5 — 30 кредитов', 'Научная стажировка как отдельный рабочий маршрут', 'Основная версия диссертации', 'Проверка публикационной готовности', 'Подготовка защитного пакета']],
      ['6 семестр', ['НИРД-6 — 18 кредитов', 'Итоговая аттестация: написание и защита докторской диссертации — 12 кредитов', 'Завершение образовательной программы', 'Подготовка к предзащите / защите', 'Обходной лист и выпускное архивное дело']],
    ],
  },
];
